

import YoutubeControl from './youtube-control'


const SELECTOR = '[data-ytid]';


function initYoutubeControl() {
	new YoutubeControl({}).init(SELECTOR).then((players) => {
		console.log('youtube control', players);
	});
}


if (window.Cookiebot) {
	if (window.Cookiebot.consent.marketing) {
		initYoutubeControl();
	} else {
		window.addEventListener('CookiebotOnLoad', function (e) {
			if (window.Cookiebot.consent.marketing) {
				initYoutubeControl();
			}
		}, false);
	}
} else {
	initYoutubeControl();
}


// //RUN  YoutubeControl({}).init(SELECTOR) when new embeds are appended
// !(function() {
// 	// Select the node that will be observed for mutations
// 	const targetNode = document.querySelector('.loadmore');

// 	// Options for the observer (which mutations to observe)
// 	const config = { attributes: true, childList: true, subtree: true };
	
// 	// Callback function to execute when mutations are observed
// 	const callback = function(mutationsList, observer) {
// 		// Use traditional 'for loops' for IE 11
// 		for(let mutation of mutationsList) {

// 			console.log('MUTATIONS', mutation)
// 			if (mutation.type === 'childList') {
// 			// GS.YTPlayer.init();
// 				new YoutubeControl({}).init(SELECTOR)
// 			}
// 			else if (mutation.type === 'attributes') {
// 				console.log('The ' + mutation.attributeName + ' attribute was modified.');
// 			}
// 		}
// 	};

// 	// Create an observer instance linked to the callback function
// 	const observer = new MutationObserver(callback);

// 	// Start observing the target node for configured mutations
// 	if(targetNode){
// 		observer.observe(targetNode, config);
// 	}
// })();

